'use client';

import * as SliderPrimitive from '@radix-ui/react-slider';
import * as React from 'react';

import { cn } from '../../lib/cn';

export interface SliderProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
	/** Nome accessibile del cursore (thumb), da passare sempre quando non c'è una `<Label>` visibile associata. */
	'aria-label'?: string;
	/** Id di un elemento label esterno che descrive il cursore, in alternativa ad `aria-label`. */
	'aria-labelledby'?: string;
}

/** Cursore per selezionare un valore numerico (o intervallo) trascinando; usalo per filtri/impostazioni numeriche. */
const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, SliderProps>(
	({ className, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, ...props }, ref) => (
		<SliderPrimitive.Root
			ref={ref}
			className={cn('relative flex w-full touch-none select-none items-center', className)}
			{...props}
		>
			<SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-secondary">
				<SliderPrimitive.Range className="absolute h-full bg-primary" />
			</SliderPrimitive.Track>
			{/* axe: aria-input-field-name — role="slider" arriva dal Thumb, non dal Root: il
		    Root non è un elemento interattivo, quindi aria-label lì non basta a dargli un
		    nome accessibile. Va passato esplicitamente al Thumb. */}
			<SliderPrimitive.Thumb
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
				className="block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
			/>
		</SliderPrimitive.Root>
	),
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
